import { OpenIdConfiguration } from 'angular-auth-oidc-client';
import { environment } from '../../../environments/environment';

export const configOidcProductSettings: OpenIdConfiguration = {
  authority: environment.authentication.issuer,
  clientId: environment.authentication.clientId,
  forbiddenRoute: '/not-authorized',
  postLogoutRedirectUri: environment.authentication.postLogoutRedirectUri,
  redirectUrl: environment.authentication.redirectUrl,
  responseType: 'code',
  scope: environment.authentication.scope,
  historyCleanupOff: false,
  unauthorizedRoute: '/login',
  // Trigger an event when authorization result is received
  triggerAuthorizationResultEvent: true,
  // Enable debug logging in non-production environments to monitor token refresh
  // logLevel: environment.env === 'prod' ? LogLevel.None : LogLevel.Debug,

  // **************** Refresh Token Configuration *******************************
  // Enable refresh token support to renew access tokens without re-authentication
  useRefreshToken: true,

  // Automatically renew tokens in the background (silent renew)
  // The library will handle token refresh automatically before expiration
  silentRenew: true,

  // Time (in seconds) before the token expires to initiate silent renewal
  // For a 2-hour token: renewal will occur at 1h 55min (with 300 seconds = 5 minutes)
  // This ensures the token is refreshed before it expires, preventing authentication errors
  renewTimeBeforeTokenExpiresInSeconds:
    environment.authentication.renewTimeBeforeTokenExpiresValue,

  // Maximum time (in seconds) to wait for a response during silent renew
  // If the renewal takes longer than this, it will timeout
  silentRenewTimeoutInSeconds: 30,

  // Disable automatic user info retrieval after authentication
  // User data will be retrieved manually when needed
  autoUserInfo: false,
};
